import axios from "axios";
import { getBaseURL } from "../utils/appConstant";

const axiosInstance = axios.create({
  baseURL: getBaseURL(),
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    //     'Access-Control-Allow-Origin' : '*',
    //   'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
  },
});

// Helper function to get cookie value
export function getCookieByKey(key: string) {
  const cookies = document.cookie.split(";"); // Split all cookies into an array
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim(); // Remove leading/trailing spaces
    if (cookie.startsWith(`${key}=`)) {
      return cookie.substring(key.length + 1); // Extract and return the value
    }
  }
  return null; // Return null if the cookie is not found
}
// Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    let csrfToken;
    if (config.url?.includes("/token/refresh")) {
      csrfToken = getCookieByKey("csrf_refresh_token");
    } else {
      csrfToken = getCookieByKey("csrf_access_token");
    }

    if (csrfToken) {
      config.headers["X-CSRF-TOKEN"] = csrfToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response?.status === 401) {
      const originalRequest = error.config;
      if (originalRequest.url.includes("/token/auth")) {
        return Promise.reject(error);
      }
      if (originalRequest.url.includes("/token/google_auth")) {
        return Promise.reject(error);
      }
 
      if (originalRequest.url.includes("/token/refresh")) {
        window.location.href = "/#/login";
        return Promise.reject(error);
      }

      try {
        await axiosInstance.post("/token/refresh");
        return axiosInstance(originalRequest);
      } catch (refreshError: any) {
        if (refreshError.response?.status === 401) {
          window.location.href = "/#/login";
        }
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
